<template>
  <div class="search-condition pega-search-condition-line-clamp">
    <template v-if="searchData.parameter.userId">
      <span
        v-if="getConditionOrUndefined('userId')"
        data-test="search-user-id"
      >
        会員ID：{{ searchData.parameter.userId }}を選択
      </span>
    </template>
    <template v-else>
      <span
        v-if="getConditionOrUndefined('age.minimum')"
        data-test="search-lower-age"
      >
        年齢下限：{{ searchData.parameter.age.minimum }}歳
      </span>
      <span
        v-if="getConditionOrUndefined('age.maximum')"
        data-test="search-upper-age"
      >
        年齢上限：{{ searchData.parameter.age.maximum }}歳
      </span>
      <span
        v-if="getConditionOrUndefined('gender')"
        data-test="search-gender"
      >
        性別：{{ convertLabel(searchData.parameter.gender,'genders') }}
      </span>
      <span
        v-if="getConditionOrUndefined('educationalBackground')"
        data-test="search-educational-background"
      >
        最終学歴：{{ convertLabel(searchData.parameter.educationalBackground,'educationalBackgrounds') }}
      </span>
      <span
        v-if="getConditionOrUndefined('graduatedSchool.keywords') && getConditionOrUndefined('graduatedSchool.keywords').length"
        data-test="search-graduated-school"
      >
        学校名/学部/学科/専攻：[{{ searchData.parameter.graduatedSchool.keywords.join('、') }}] {{ searchData.parameter.graduatedSchool.operator | parseOperator }}
      </span>
      <span
        v-if="graduationYear"
        data-test="search-graduated-school-year"
      >
        卒業年：{{ graduationYear }}
      </span>
      <span
        v-if="getConditionOrUndefined('changeOverJobsCount.maximum') || getConditionOrUndefined('changeOverJobsCount.maximum') === 0"
        data-test="search-changeover-jobs-count"
      >
        転職回数：{{ searchData.parameter.changeOverJobsCount.maximum }}回以内
      </span>
      <span
        v-if="getConditionOrUndefined('employed') || getConditionOrUndefined('employed') === false"
        data-test="search-employed"
      >
        就業状況：{{ searchData.parameter.employed | convertEmployedLabel }}
      </span>
      <span
        v-if="getConditionOrUndefined('annualSalary.minimum')"
        data-test="search-lower-annual-salary"
      >
        直近の年収下限：{{ searchData.parameter.annualSalary.minimum }}万円
      </span>
      <span
        v-if="getConditionOrUndefined('annualSalary.maximum')"
        data-test="search-upper-annual-salary"
      >
        直近の年収上限：{{ searchData.parameter.annualSalary.maximum }}万円
      </span>
      <span
        v-if="getConditionOrUndefined('desiredSalary.minimum')"
        data-test="search-lower-desired-salary"
      >
        希望年収下限：{{ searchData.parameter.desiredSalary.minimum }}万円
      </span>
      <span
        v-if="getConditionOrUndefined('desiredSalary.maximum')"
        data-test="search-upper-desired-salary"
      >
        希望年収上限：{{ searchData.parameter.desiredSalary.maximum }}万円
      </span>
      <span
        v-if="getConditionOrUndefined('address.prefectures') && getConditionOrUndefined('address.prefectures').length && getConditionOrUndefined('address.selectedOption') === null"
        data-test="search-prefectures"
      >
        {{ convertNonHopeUser('現住所・希望勤務地','address.containNonHopeUser') }}：[{{ searchData.parameter.address.prefectures.map(id => convertLabelForLv2(id, 'prefectures')).join('、') }}]
      </span>
      <span
        v-else-if="getConditionOrUndefined('address.prefectures') && getConditionOrUndefined('address.prefectures').length && getConditionOrUndefined('address.selectedOption') === 'present'"
        data-test="search-prefectures"
      >
        現住所：[{{ searchData.parameter.address.prefectures.map(id => convertLabelForLv2(id, 'prefectures')).join('、') }}]
      </span>
      <span
        v-else-if="getConditionOrUndefined('address.prefectures') && getConditionOrUndefined('address.prefectures').length && getConditionOrUndefined('address.selectedOption') === 'desired'"
        data-test="search-prefectures"
      >
        {{ convertNonHopeUser('希望勤務地', 'address.containNonHopeUser') }}：[{{ searchData.parameter.address.prefectures.map(id => convertLabelForLv2(id, 'prefectures')).join('、') }}]
      </span>
      <span
        v-if="occupationOperatorLabel(getConditionOrUndefined('occupations.operator'))"
        data-test="occupations-operator"
      >
        {{ occupationOperatorLabel(getConditionOrUndefined('occupations.operator')) }}
      </span>
      <span
        v-if="getConditionOrUndefined('occupations.experienced') && getConditionOrUndefined('occupations.experienced').length"
        data-test="search-occupations"
      >
        経験職種：[{{ searchData.parameter.occupations.experienced.map(x => occupationLabel(x)).join('、') }}]
      </span>
      <span
        v-if="getConditionOrUndefined('occupations.desired') && getConditionOrUndefined('occupations.desired').length"
        data-test="search-occupations"
      >
        {{ convertNonHopeUser('希望職種', 'occupations.containNonHopeUser') }}：[{{ searchData.parameter.occupations.desired.map(x => occupationLabel(x, false)).join('、') }}]
      </span>
      <span
        v-if="businessOperatorLabel(getConditionOrUndefined('businesses.operator'))"
        data-test="business-operator"
      >
        {{ businessOperatorLabel(getConditionOrUndefined('businesses.operator')) }}
      </span>
      <span
        v-if="getConditionOrUndefined('businesses.experienced') && getConditionOrUndefined('businesses.experienced').length"
        data-test="search-sectors"
      >
        経験業種：[{{ searchData.parameter.businesses.experienced.map(id => convertLabelForLv2(id, 'businesses')).join('、') }}]
      </span>
      <span
        v-if="getConditionOrUndefined('businesses.desired') && getConditionOrUndefined('businesses.desired').length"
        data-test="search-sectors"
      >
        {{ convertNonHopeUser('希望業種', 'businesses.containNonHopeUser') }}：[{{ searchData.parameter.businesses.desired.map(id => convertLabelForLv2(id, 'businesses')).join('、') }}]
      </span>
      <span
        v-if="getConditionOrUndefined('hasCareerResumes')"
        data-test="search-has-career-resumes"
      >
        「職務経歴」登録済みのみ
      </span>
      <span
        v-if="searchData.parameter.targetBehavior > 1"
        data-test="search-target-behavior"
      >
        行動ターゲティング：{{ labelValueBehaviorByKey(searchData.parameter.targetBehavior) }}
      </span>
      <span
        v-if="getConditionOrUndefined('activeRecent') || getConditionOrUndefined('activeRecent') === 0"
        data-test="search-active-recent"
      >
        最終ログイン：{{ searchData.parameter.activeRecent }}日以内
      </span>
      <span
        v-if="getConditionOrUndefined('toeicScore.minimum')"
        data-test="search-toeic-score"
      >
        TOEIC：{{ searchData.parameter.toeicScore.minimum }}点以上
      </span>
      <span
        v-if="getConditionOrUndefined('toeflScore.minimum')"
        data-test="search-toefl-score"
      >
        TOEFL：{{ searchData.parameter.toeflScore.minimum }}点以上
      </span>
      <span
        v-if="getConditionOrUndefined('englishSkill.minimum')"
        data-test="search-english-skill"
      >
        英語スキル：{{ convertLabel(searchData.parameter.englishSkill.minimum, 'languageSkills') }}
      </span>
      <span
        v-if="getConditionOrUndefined('changeJobsMotivations') && getConditionOrUndefined('changeJobsMotivations').length"
        data-test="search-change-jobs-motivations"
      >
        転職意欲：{{ searchData.parameter.changeJobsMotivations.map(id => convertLabel(id, 'changeJobsMotivations')).join('、') }}
      </span>
      <span
        v-if="getConditionOrUndefined('companyStyle')"
        data-test="search-company-style"
      >
        希望している会社のタイプ：{{ convertLabel(searchData.parameter.companyStyle, 'companyStyles') }}
      </span>
      <span
        v-if="getConditionOrUndefined('searchingOccupations') && getConditionOrUndefined('searchingOccupations').length"
        data-test="search-searching-occupations"
      >
        職種で検索している会員を探す：[{{ searchData.parameter.searchingOccupations.map(id => smallOccupationsLabelById(id)).join('、') }}]
      </span>
      <span
        v-if="getConditionOrUndefined('searchingWorkPrefectures') && getConditionOrUndefined('searchingWorkPrefectures').length"
        data-test="search-searching-work-prefectures"
      >
        勤務地で検索している会員を探す：[{{ searchData.parameter.searchingWorkPrefectures.map(id => convertLabelForLv2(id, 'prefectures')).join('、') }}]
      </span>
      <span
        v-if="getConditionOrUndefined('searchingBusinesses') && getConditionOrUndefined('searchingBusinesses').length"
        data-test="search-searching-sectors"
      >
        業種で検索している会員を探す：[{{ searchData.parameter.searchingBusinesses.map(id => convertLabelForLv2(id, 'businesses')).join('、') }}]
      </span>
      <span
        v-if="getConditionOrUndefinedCondition('selectedRegistrationDateValue.terms') || getConditionOrUndefinedCondition('selectedRegistrationDateValue.terms') === 0"
        data-test="search-registration-date"
      >
        登録時期：{{ searchData.condition.selectedRegistrationDateValue.name }}
      </span>
      <span v-if="getConditionOrUndefined('registrationDate.selectedDateTimeWithinDays') === null">
        <span
          v-if="getConditionOrUndefined('registrationDate.selectedDateTimeRangeForm.from')"
          data-test="search-registration-date-from"
        >
          登録時期From：{{ searchData.parameter.registrationDate.selectedDateTimeRangeForm.from }}
        </span>
        <span
          v-if="getConditionOrUndefined('registrationDate.selectedDateTimeRangeForm.to')"
          data-test="search-registration-date-to"
        >
          登録時期To：{{ searchData.parameter.registrationDate.selectedDateTimeRangeForm.to }}
        </span>
      </span>
      <span
        v-if="getConditionOrUndefinedCondition('selectedResumeUpdateDateValue.terms') || getConditionOrUndefinedCondition('selectedResumeUpdateDateValue.terms') === 0"
        data-test="search-resume-update-date"
      >
        レジュメ更新日：{{ searchData.condition.selectedResumeUpdateDateValue.name }}
      </span>
      <span v-if="getConditionOrUndefined('resumeUpdateDate.selectedDateTimeWithinDays') === null">
        <span
          v-if="getConditionOrUndefined('resumeUpdateDate.selectedDateTimeRangeForm.from')"
          data-test="search-resume-update-date-from"
        >
          レジュメ更新日From：{{ searchData.parameter.resumeUpdateDate.selectedDateTimeRangeForm.from }}
        </span>
        <span
          v-if="getConditionOrUndefined('resumeUpdateDate.selectedDateTimeRangeForm.to')"
          data-test="search-resume-update-date-to"
        >
          レジュメ更新日To：{{ searchData.parameter.resumeUpdateDate.selectedDateTimeRangeForm.to }}
        </span>
      </span>
      <span
        v-if="getConditionOrUndefined('activeDate.from')"
        data-test="search-active-date-from"
      >
        最終ログイン時期From：{{ searchData.parameter.activeDate.from }}
      </span>
      <span
        v-if="getConditionOrUndefined('activeDate.to')"
        data-test="search-active-date-to"
      >
        最終ログイン時期To：{{ searchData.parameter.activeDate.to }}
      </span>
      <span
        v-if="getConditionOrUndefined('freeWord.keywords') && getConditionOrUndefined('freeWord.keywords').length"
        data-test="search-free-word"
      >
        フリーワード：[{{ searchData.parameter.freeWord.keywords.join('、') }}] {{ searchData.parameter.freeWord.operator | parseOperator }}
      </span>
      <span
        v-if="getConditionOrUndefined('excludeWord.keywords') && getConditionOrUndefined('excludeWord.keywords').length"
        data-test="search-exclude-word"
      >
        除外ワード：[{{ searchData.parameter.excludeWord.keywords.join('、') }}] {{ searchData.parameter.excludeWord.operator | parseOperator }}
      </span>
      <span
        v-if="getConditionOrUndefined('skills.conditions') && getConditionOrUndefined('skills.conditions').length"
        data-test="search-skills"
      >
        スキル：[{{ skillsConditionLabel }}] {{ searchData.parameter.skills.operator | parseOperator }}
      </span>
      <span
        v-if="getConditionOrUndefined('licenses.ids') && getConditionOrUndefined('licenses.ids').length"
        data-test="search-licenses"
      >
        資格：[{{ searchData.parameter.licenses.ids.map(id => licensesLabelById(id)).join('、') }}] {{ searchData.parameter.licenses.operator | parseOperator }}
      </span>
      <span
        v-if="getConditionOrUndefined('excludedApproachedScout.otherCompany.maximum')"
        data-test="approached-other-company"
      >
        他社からのスカウト受け取り数：{{ searchData.parameter.excludedApproachedScout.otherCompany.maximum }}社以内
      </span>
      <span
        v-if="getConditionOrUndefinedCondition('selectedApproachedThisJobOptionValue.terms') || getConditionOrUndefinedCondition('selectedApproachedThisJobOptionValue.terms') === 0"
        data-test="approached-this-job"
      >
        この自社求人のスカウト時期で除外：{{ searchData.condition.selectedApproachedThisJobOptionValue.name }}
      </span>
      <span v-if="getConditionOrUndefined('excludedApproachedScout.ownCompany.thisJob.selectedDateTimeWithinDays') === null">
        <span
          v-if="getConditionOrUndefined('excludedApproachedScout.ownCompany.thisJob.selectedDateTimeRangeForm.from')"
          data-test="approached-this-job-from"
        >
          From：{{ searchData.parameter.excludedApproachedScout.ownCompany.thisJob.selectedDateTimeRangeForm.from | parseDate }}
        </span>
        <span
          v-if="getConditionOrUndefined('excludedApproachedScout.ownCompany.thisJob.selectedDateTimeRangeForm.to')"
          data-test="approached-this-job-to"
        >
          To：{{ searchData.parameter.excludedApproachedScout.ownCompany.thisJob.selectedDateTimeRangeForm.to | parseDate }}
        </span>
      </span>
      <span
        v-if="getConditionOrUndefinedCondition('selectedApproachedOtherJobOptionValue.terms') || getConditionOrUndefinedCondition('selectedApproachedOtherJobOptionValue.terms') === 0"
        data-test="approached-other-job"
      >
        その他の自社求人のスカウト時期で除外：{{ searchData.condition.selectedApproachedOtherJobOptionValue.name }}
      </span>
      <span v-if="getConditionOrUndefined('excludedApproachedScout.ownCompany.otherJob.selectedDateTimeWithinDays') === null">
        <span
          v-if="getConditionOrUndefined('excludedApproachedScout.ownCompany.otherJob.selectedDateTimeRangeForm.from')"
          data-test="approached-other-job-from"
        >
          From：{{ searchData.parameter.excludedApproachedScout.ownCompany.otherJob.selectedDateTimeRangeForm.from | parseDate }}
        </span>
        <span
          v-if="getConditionOrUndefined('excludedApproachedScout.ownCompany.otherJob.selectedDateTimeRangeForm.to')"
          data-test="approached-other-job-to"
        >
          To：{{ searchData.parameter.excludedApproachedScout.ownCompany.otherJob.selectedDateTimeRangeForm.to | parseDate }}
        </span>
      </span>
      <span
        v-if="getConditionOrUndefinedCondition('selectedLikedOptionValue.terms') || getConditionOrUndefinedCondition('selectedLikedOptionValue.terms') === 0"
        data-test="liked-date"
      >
        いいねを送信した時期を指定して除外：{{ searchData.condition.selectedLikedOptionValue.name }}
      </span>
      <span v-if="getConditionOrUndefined('excludedApproachedLiked.selectedDateTimeWithinDays') === null">
        <span
          v-if="getConditionOrUndefined('excludedApproachedLiked.selectedDateTimeRangeForm.from')"
          data-test="liked-date-from"
        >
          From：{{ searchData.parameter.excludedApproachedLiked.selectedDateTimeRangeForm.from | parseDate }}
        </span>
        <span
          v-if="getConditionOrUndefined('excludedApproachedLiked.selectedDateTimeRangeForm.to')"
          data-test="liked-date-to"
        >
          To：{{ searchData.parameter.excludedApproachedLiked.selectedDateTimeRangeForm.to | parseDate }}
        </span>
      </span>
      <span
        v-if="getConditionOrUndefined('excludedCandidateOtherJob')"
        data-test="excluded-candidate-other-company-job"
      >
        送信候補：その他の自社求人で送信候補に入れている会員を除外
      </span>
      <span
        v-if="getConditionOrUndefined('excludeEntryOtherCompanyJob') || getConditionOrUndefined('excludeCasualInterviewEntryOtherCompanyJob') "
        data-test="exclude-entry-other-company-job"
      >
        {{ getExcludeEntryOtherCompanyJobLabel }}
      </span>
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import * as definition from '@/lib/labelValueMappings'
import { parseHierarchicalObjects } from '@/lib/parse'
import _ from 'lodash'
import { createDate } from '@/lib/dateUtils.js'
import { SearchDataModel } from '@/model/searchDataModel'

export default {
  name: 'SettingAutoLikedCondition',
  filters: {
    convertEmployedLabel (value) {
      return value || value === false ? definition.employed.find(employed => employed.value === value).name : ''
    },
    parseOperator (operator) {
      return operator === 'and' ? 'すべてを含む' : 'いずれかを含む'
    },
    parseDate (val) {
      return createDate(val)?.format('YYYY/MM/DD')
    }
  },
  props: {
    condition: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      searchData: new SearchDataModel()
    }
  },
  computed: {
    ...mapGetters({
      skillsMaster: 'skillsMaster'
    }),
    behaviorLabelValues () {
      return definition.behaviors
    },
    skillsConditionLabel () {
      if (!this.searchData.parameter.skills || !this.searchData.parameter.skills.conditions) return ''

      const experiences = this.getSkillExperiences(1)
      return Object.keys(experiences).map(key => {
        const experienceValues = _.at(experiences, key).reduce((arr, it) => (it) ? [...arr, ...it] : arr)
        experienceValues.map(val => {
          val.year = this.searchData.parameter.skills.conditions.find(skill => Number(skill.id) === val.id).years.minimum
        })

        const subCategories = _.groupBy(experienceValues, val => {
          return val.path[0].name
        })

        return `${key}：` + Object.keys(subCategories).map(key => {
          return `[${key}]${subCategories[key].map(i => i.name + '（' + definition.searchSkillExperienceRange.find(item => item.id === i.year + '').name + '）').join('、')}`
        }).join('、')
      }).join('、')
    },
    graduationYear () {
      const from = this.getConditionOrUndefined('graduatedSchool.year.from')
      const to = this.getConditionOrUndefined('graduatedSchool.year.to')
      if (from && to) {
        return `${from}年〜${to}年`
      } else if (from) {
        return `${from}年〜`
      } else if (to) {
        return `〜${to}年`
      } else {
        return ''
      }
    },
    getExcludeEntryOtherCompanyJobLabel () {
      const excludeEntryOtherCompanyJobArray = []
      if (this.searchData.parameter.excludeEntryOtherCompanyJob) {
        excludeEntryOtherCompanyJobArray.push(_.find(definition.excludeEntryOtherCompanyJob, { key: 'excludeEntryOtherCompanyJob' }).label)
      }
      if (this.searchData.parameter.excludeCasualInterviewEntryOtherCompanyJob) {
        excludeEntryOtherCompanyJobArray.push(_.find(definition.excludeEntryOtherCompanyJob, { key: 'excludeCasualInterviewEntryOtherCompanyJob' }).label)
      }
      return `他求人への応募：${excludeEntryOtherCompanyJobArray.join('、')}`
    }
  },
  created () {
    const masters = [
      'genders',
      'educationalBackgrounds',
      'prefectures',
      'occupations',
      'businesses',
      'languageSkills',
      'changeJobsMotivations',
      'companyStyles',
      'skills',
      'licenses'
    ]
    masters.forEach(element => {
      this.storeMaster(element)
    })
    // PropsをSearchDataModelの型に変換する
    this.$set(this, 'searchData', new SearchDataModel({
      id: this.condition.id,
      parameter: this.condition.parameter,
      condition: JSON.parse(this.condition.condition)
    }))
  },
  methods: {
    ...mapActions([
      'storeMaster'
    ]),
    convertLabel (id, mastersKey) {
      return this.$store.getters.convertLabelById(id, mastersKey)
    },
    convertLabelForLv2 (id, mastersKey) {
      return this.$store.getters.convertLabelForLv2ById(id, mastersKey)
    },
    convertNonHopeUser (label, path) {
      if (this.getConditionOrUndefined(path)) {
        label = label + '(こだわらない・未入力の会員を含む)'
      }
      return label
    },
    smallOccupationsLabelById (id) {
      return this.$store.getters.lowerLayerLabel(id, 'occupations')
    },
    occupationLabel (occupation, showYearLabel = true) {
      // 経験職種(showYearLabel = true)・希望職種( showYearLabel = false)で呼ばれている
      const convertYearId = showYearLabel && (occupation.years.minimum !== null) ? _.toString(occupation.years.minimum) : null
      const yearLabel = showYearLabel ? `（${_.find(definition.searchOccupationExperienceRange, { id: convertYearId }).name}）` : ''
      return `${this.smallOccupationsLabelById(occupation.id)}${yearLabel}`
    },
    occupationOperatorLabel (key) {
      const experienced = this.getConditionOrUndefined('occupations.experienced') || []
      const desired = this.getConditionOrUndefined('occupations.desired') || []
      return experienced.length || desired.length ? _.find(definition.occupationOperators, { key: key }).label : ''
    },
    businessOperatorLabel (key) {
      const experienced = this.getConditionOrUndefined('businesses.experienced') || []
      const desired = this.getConditionOrUndefined('businesses.desired') || []
      return experienced.length || desired.length ? _.find(definition.businessOperators, { key: key }).label : ''
    },
    getConditionOrUndefined (path) {
      return _.get(this.searchData.parameter, path)
    },
    getConditionOrUndefinedCondition (path) {
      return _.get(this.searchData.condition, path)
    },
    hasKeyOfBehavior (key, targetBehavior) {
      let flg = false
      if (targetBehavior) {
        targetBehavior.forEach(x => {
          flg = x === key
        })
      }
      return flg
    },
    labelValueBehaviorByKey (key) {
      return _.find(definition.behaviors, { value: key }).label
    },
    licensesLabelById (id) {
      return this.convertLabelForLv2(id, 'licenses')
    },
    getSkillExperiences (groupLayer) {
      return _.groupBy(
        _.filter(parseHierarchicalObjects(this.skillsMaster), master => {
          return this.searchData.parameter.skills.conditions.some(skill => Number(skill.id) === master.id)
        }),
        o => o.path[groupLayer].name
      )
    }
  }
}
</script>
